// extracted by css-extract-rspack-plugin
export default {"appointmentSelector":"appointmentSelector-bD_JUH"};